import React from 'react';
import { ReactNode } from "react";

import { Navbar, Nav, Container } from 'react-bootstrap';
import {IAppConfig } from "../App_v01_Interfaces";

import { IItemList, IItem, IItemFact } from '../App_v01_Interfaces';

interface FeatureListProps{
  appFeatures: IItemList;
}//end:



// interface AppConfigProps{
//   appConfig: IAppConfig;
// }//end:



// const Navbar_v01: React.FC<AppConfigProps> = ({appConfig}) => {


// <div class="accordion" id="accordionExample">
//   <div class="accordion-item">
//     <h2 class="accordion-header" id="headingOne">
//       <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
//         Accordion Item #1
//       </button>
//     </h2>
//     <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
//       <div class="accordion-body">
//         <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
//       </div>
//     </div>
//   </div>






const Features_v01Accordian: React.FC<FeatureListProps> = ({appFeatures}) => {
  
  return (
    
                <>
                <div className="container">
                    <div className="my-accordion accordion-flush" id="accordionFlushExample">
                    {appFeatures.Items.map((feature: IItem, index) => {
                        const isEven = index % 2 === 0;
                        const collapseId = `flush-collapse-${index}`;
                        const headingId = `flush-heading-${index}`;

                        return (
                        <div key={index}>
                            <hr className="featurette-divider" />
                            <div className="row featurette">
                            <div className={`col-md-7 ${isEven ? "" : "order-md-2"}`}>
                                <div className="my-accordion-item-content">

                                <h2 className="accordion-header" id={headingId}>

                                 
                                    <button
                                        className="accordion-button collapsed my-accordion-toggle my-feature-heading"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#${collapseId}`}
                                        aria-expanded="false"
                                        aria-controls={collapseId}
                                    >
                                    {
                                    /* 
                                        <span className="featurette-heading text-muted">{feature.Title}</span> 
                                        featurette-heading 
                                    */
                                    }

                                    <h2>{feature.Title}</h2>
                                    <span className="arrow-icon">&#9662;</span> {/* ▼ */}

                                    </button>
                                    <h4>{feature.Description}</h4>
                                 
                                    
                                </h2>

                                <div
                                    id={collapseId}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={headingId}
                                    data-bs-parent="#accordionFlushExample"
                                >
                                    <div className="accordion-body">

                                    {/* <p className="lead">{feature.Description}</p> */}
                                    {feature.ItemFacts?.map((fact: IItemFact, factIndex) => (
                                        
                                        
                                        <div className="ms-3" key={factIndex}>
                                            <a href="/businessInsurance"><div><b>{fact.Title}</b></div></a>
                                            <div>{fact.Description}</div>
                                        </div>
                                        
                                    ))}
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div className={`col-md-5 ${isEven ? "" : "order-md-1"}`}>
                                <img
                                width="425"
                                height="425"
                                className="img-fluid mx-auto"
                                src={feature.ImageLink}
                                alt={`Feature ${index + 1}`}
                                />
                            </div>
                            </div>
                        </div>
                        );
                    })}
                    <hr className="featurette-divider" />
                    </div>
                </div>
                
                </>


  );
};

export default Features_v01Accordian;
